import React, { createContext, useContext, useEffect, useState } from 'react';
import { MapContext } from './map-ctx';
import L from 'leaflet';

export const MarkerLayerContext = createContext<L.LayerGroup | null>(null);

/**
 * Marker layer without clustering
 */
export const MarkerLayer: React.FC = ({ children }) => {
  const { map } = useContext(MapContext);
  const [layerGroup, setLayerGroup] = useState<L.LayerGroup | null>(null);

  useEffect(() => {
    const mapRef = map.current?.ref;
    if (mapRef) {
      const newLayerGroup = L.layerGroup();

      newLayerGroup.addTo(mapRef);
      setLayerGroup(newLayerGroup);

      return () => {
        if (mapRef && newLayerGroup) {
          mapRef?.removeLayer(newLayerGroup);
        }
        setLayerGroup(null);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map.current]);

  return (
    <MarkerLayerContext.Provider value={layerGroup}>
      {children}
    </MarkerLayerContext.Provider>
  );
};
